<!--
Author: TangChen
Date: 2019-10-23
Desc: 基本信息
 -->
<template>
    <div :class="'view-org-type view bg-white' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <div class="sel-org-cate">
            <div class="tit">
                请选择开户主体类型
            </div>
            <div class="sel-con">
                <div class="sel-list b-white">
                    <div class="list-icon bt-white">
                        <span class="icon bg-main"></span>
                        <span class="text">机构开户</span>
                        <p class="grey">
                            以公司为主体进行开户，通过基金资产配置对公司自有资产进行管理
                        </p>
                    </div>
                    <div class="btn main" v-on:click.prevent="initData('0')">
                        <span>选择并继续<i class="fa fa-long-arrow-right"></i></span>
                    </div>
                </div>
                <div class="sel-list b-white">
                    <div class="list-icon bt-white">
                        <span class="icon bg-secondary"></span>
                        <span class="text">产品开户</span>
                        <p class="grey">
                            以理财产品为主体开户，如金融机构集合计划开户、定向资产管理计划开户、企业年金开户、保险产品开户、信托产品开户等
                        </p>
                    </div>
                    <div class="btn secondary" v-on:click.prevent="initData('2')">
                        <span>选择并继续<i class="fa fa-long-arrow-right"></i></span>
                    </div>
                </div>
            </div>
        </div>
        <!--内容-->
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import navBar from "@/components/common/navBar.vue";
export default {
    name: "ViewOrgType",
    components: {
        navBar
    },
    mixins: [mixin],
    data () {
        return {
            navs: [
                {id: "1",val: "经办人信息"},
                {id: "2",val: "基本信息",active: "1"},
                {id: "3",val: "信息登记"},
                {id: "4",val: "银行信息"},
                {id: "5",val: "文件上传"},
                {id: "6",val: "完成注册",icon: "fa fa-check"}
            ]
        };
    },
    mounted() {

    },
    methods: {
        initData(val){
            this.$router.push({name: "basicinfo",query: {type: val}});
        }
    }
};
</script>
<style lang="scss">
    .view-org-type {
        margin-top: 5px;
        padding: 10px 55px;
        .sel-org-cate{
            padding: 10px 0 50px;
            text-align: center;
            .tit{font-size: 24px;line-height: 36px;padding: 20px 0;}
        }
        .sel-con{
            .sel-list{width: 320px;display: inline-block;&:last-child{margin-left: 50px;}}
            .list-icon{
                height: 286px;
                padding: 26px 22px 10px;line-height: 24px;
                .icon{display: inline-block;height: 160px;width: 160px;border-radius: 50%;background-position: 50% 50%;background-repeat: no-repeat;}
                .text{padding: 10px 0;display: block;font-size: 16px;}
            }
            .btn{font-size: 16px;line-height: 50px;cursor:pointer;i{margin-left: 3px;}}
        }
        /*颜色，背景写在css/theme.scss内views style下*/
    }
</style>
